import React, {Component} from "react";
import BsySelect from "../BsySelect";
import {BsyUtils} from "../../utils/Utils";
import SelectTree from "./SelectTree";

class AddRole extends Component {
  static defaultProps = {
    targetRoleList: []
  }

  constructor(props) {
    super(props);
    this.state = {
      members: [],
      users: []
    }
  }

  componentDidMount() {
    this.props.getContext(this);
  }

  componentWillUnmount() {
    this.targetRoleGroup = null;
    this.roleName = "";
  }

  targetRoleGroup = null

  roleName = "";

  onChangeRoleName = (event) => {
    this.roleName = event.target.value;
  }

  selectMembersUser = () => {
    const that = this;
    const e = new window.FX.ConfirmDialog({
      title: React.language("widget.user.listTitle"),
      height: 577,
      width: 956,
      contentWidget: {
        rowSize: [440],
        colSize: [926],
        padding: 15,
        items: [[{
          widgetName: "memberSelect",
          type: "memberselectpane",

          editable: !0,
          roleEnable: 0,
          hasDock: false,
          departmentEnable: !1,
          hasTeamManageBtn: !1,
          outsiderMemberEnable: !1,
          outsiderGroupEnable: !1,
          value: this.state.users
        }]]
      },
      onOk: function () {
        const members = [];
        const dept = e.getWidgetByName("memberSelect");
        const d1 = dept.getAllJsonValue();
        const newUser = d1.newUser;
        const users = d1.users;
        const usesMap = {};
        newUser.map(res=>{
          usesMap[res._id] = res;
        })

        users.map(id=>{
          usesMap[id] && members.push(usesMap[id])
        })

        that.setState({members, users});
        return !1
      }
    });
    e.show()
  }

  render() {
    const { members } = this.state;
    const { targetRoleList } = this.props;
    return (
      <div className="AddRole">
        <div className="createRolePane">
          <div className="createRoleItem">
            <div className="item-title">
              <b>*</b>
              {React.language("corp.dingtalk.Step4.name")}
            </div>
            <input autoFocus={true} className="roleNameInput" type="text" placeholder={React.language("role.name.placeholder")} onChange={this.onChangeRoleName}/>
          </div>
          {!this.props.isAddChild && <div className="createRoleItem">
            <div className="item-title">
              {React.language("target.group")}
            </div>
            <BsySelect
              hasClearSelect={true}
              notSelectClose={true}
              allowBlank={false}
              height={34}
              hasSelectAll={false}
              hasSelectEmpty={false}
              value={this.targetRoleGroup}
              items={targetRoleList}
              onCustomList={(t)=>{
                return <SelectTree selectContext={t}/>
              }}
              onStopEdit={e1 => {
                this.targetRoleGroup = e1;
              }}
            />
          </div>}
          <div className="createRoleItem">
            <div className="item-title">
              {React.language("member")}
            </div>
            <div className='membersCont' onClick={this.selectMembersUser}>
              {
                members.length === 0 ? <div className="select-empty"><span>{React.language('widget.user.clickToSelect1')}</span></div> :
                  <div className="addMembersUser">
                    {
                      members.map((item, index) => {
                        let name = item.nickname;
                        let avatarurl = item.avatar;
                        const bg = name ? BsyUtils.formatUserThumb(name.toString()) : '';
                        return <div className="item-content department"><div className="avatar">
                            {!!avatarurl ? <img src={avatarurl} alt="" /> : <div className={`table-user-portrait-name color-${bg.color}`}><span>{bg.name}</span></div>}
                          </div><span>{name}</span></div>
                      })
                    }
                  </div>
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AddRole;